import api from './api';

export default {
    async getAllCertificates(accessToken) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.get('/certificate', {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados dos certificados:', error);
            throw error;
        }
    },
    async createNewCertificate(accessToken, payload) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.post('/certificate', payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao criar novo certificado:', error);
            throw error;
        }
    },
    async getCertificate(accessToken, id) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.get(`/certificate/${id}`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter o modelo de certificado:', error);
            throw error;
        }
    },
    async getIssuedCertificate(accessToken, courseId, studentId) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.get(
                `/certificate/issued/${courseId}/${studentId}`,
                { headers },
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao consultar o certificado emitido:', error);
            throw error;
        }
    },
    async editCertificate(accessToken, id, payload) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.put(`/certificate/${id}`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao editar certificado:', error);
            throw error;
        }
    },
    async deleteCertificate(accessToken, id) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.delete(`/certificate/${id}`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao deletar certificado:', error);
            throw error;
        }
    },
};
